import React, { createContext, useContext, useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

const CountryContext = createContext();

export const CountryProvider = ({ children }) => {
  const { country } = useParams();
  const [countryData, setCountryData] = useState({
    code: country || 'us',
    name: getCountryName(country || 'us'),
    language: getCountryLanguage(country || 'us'),
  });

  useEffect(() => {
    if (country) {
      setCountryData({
        code: country,
        name: getCountryName(country),
        language: getCountryLanguage(country),
      });
    }
  }, [country]);

  return (
    <CountryContext.Provider value={countryData}>
      {children}
    </CountryContext.Provider>
  );
};

export const useCountry = () => useContext(CountryContext);

// Helper functions
function getCountryName(code) {
  const countries = {
    us: 'United States',
    uk: 'United Kingdom',
    in: 'India',
    ca: 'Canada',
    au: 'Australia',
    de: 'Germany',
    fr: 'France',
    es: 'Spain',
    it: 'Italy',
    jp: 'Japan',
    br: 'Brazil',
    mx: 'Mexico',
    ru: 'Russia',
    sg: 'Singapore',
    ae: 'United Arab Emirates',
    sa: 'Saudi Arabia',
    za: 'South Africa',
    nl: 'Netherlands',
    se: 'Sweden',
    ch: 'Switzerland'
  };
  return countries[code.toLowerCase()] || 'United States';
}

function getCountryLanguage(code) {
  const languages = {
    us: 'en-US',
    uk: 'en-GB',
    in: 'en-IN',
    ca: 'en-CA',
    au: 'en-AU',
    de: 'de-DE',
    fr: 'fr-FR',
    es: 'es-ES',
    it: 'it-IT',
    jp: 'ja-JP',
    br: 'pt-BR',
    mx: 'es-MX',
    ru: 'ru-RU',
    sg: 'en-SG',
    ae: 'ar-AE',
    sa: 'ar-SA',
    za: 'en-ZA',
    nl: 'nl-NL',
    se: 'sv-SE',
    ch: 'de-CH'
  };
  return languages[code.toLowerCase()] || 'en-US';
}